import { render, staticRenderFns } from "./PlayerLoot.vue?vue&type=template&id=631059e4&scoped=true"
import script from "./PlayerLoot.vue?vue&type=script&lang=js"
export * from "./PlayerLoot.vue?vue&type=script&lang=js"
import style0 from "./PlayerLoot.vue?vue&type=style&index=0&id=631059e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631059e4",
  null
  
)

export default component.exports